import { fn, get } from '@ember/helper';
import { on } from '@ember/modifier';
import { action, set } from '@ember/object';
import Component from '@glimmer/component';
import EmberTooltip from '@mylighthouse/prism-ember/components/ember-tooltip';
import displayFrequency from 'lumen/helpers/display-frequency';

interface SettingsReportsTablesCellsTdFrequencySignature {
  Args: {
    cellData: unknown;
  };
}

export default class SettingsReportsTablesCellsTdFrequency extends Component<SettingsReportsTablesCellsTdFrequencySignature> {
  isHovered = false;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get reportGroup() {
    return this.args.cellData;
  }

  @action
  // @ts-expect-error: Incorrect type
  isCellHovered(isHovered): void {
    set(this, 'isHovered', isHovered);
  }

  <template>
    {{! @glint-nocheck }}
    <div
      class="truncate"
      role="tooltip"
      {{on "mouseenter" (fn this.isCellHovered true)}}
      {{on "mouseleave" (fn this.isCellHovered false)}}
    >
      {{#if @cellData.reports}}
        {{displayFrequency
          (get @cellData.reports "0.dayOfWeek")
          (get @cellData.reports "0.frequency")
          (get @cellData.reports "0.type")
          (get @cellData.shopconfigs "0.frequencyType")
        }}
      {{/if}}
    </div>
    {{#if this.isHovered}}
      <EmberTooltip
        @isShown={{this.isHovered}}
        @tooltipClass="default-tooltip default-tooltip--large"
      >
        {{displayFrequency
          (get @cellData.reports "0.dayOfWeek")
          (get @cellData.reports "0.frequency")
          (get @cellData.reports "0.type")
          (get @cellData.shopconfigs "0.frequencyType")
        }}
      </EmberTooltip>
    {{/if}}
  </template>
}
